/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * RumbleDirect API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DataAnalyticsBrandResourceBrandOutputJson,
  DataAnalyticsCauseOfDamageResourceCauseOfDamageOutputJson,
  DataAnalyticsDamageFromDirectionResourceDamageFromDirectionOutputJson,
  DataAnalyticsDealershipLocationResourceDealershipLocationOutputJson,
  DataAnalyticsDossierTypeResourceDossierTypeOutputJson,
  DataAnalyticsDossiersPerDamageDateResourceDossiersPerDamageDateOutputJson,
  DataAnalyticsDriveableResourceDriveableOutputJson,
  DataAnalyticsExternalInsuredResourceExternalInsuredOutputJson,
  DataAnalyticsFleetLeaseLabelTypeResourceFleetLeaseLabelTypeOutputJson,
  DataAnalyticsGlassJobTypeResourceGlassJobTypeOutputJson,
  DataAnalyticsGuaranteeFundResourceGuaranteeFundOutputJson,
  DataAnalyticsHasImagesResourceHasImagesOutputJson,
  DataAnalyticsHasRepairAppointmentResourceHasRepairAppointmentOutputJson,
  DataAnalyticsLeaseCompanyResourceLeaseCompanyOutputJson,
  DataAnalyticsMediaIntentPerDayResourceMediaIntentPerDayOutputJson,
  DataAnalyticsOtherPartyInvolvedResourceOtherPartyInvolvedOutputJson,
  DataAnalyticsOwnershipResourceOwnershipOutputJson,
  DataAnalyticsPhotosPerDossierResourcePhotosPerDossierOutputJson,
  DataAnalyticsRepairRequestedResourceRepairRequestedOutputJson,
  DataAnalyticsRepairTypeResourceRepairTypeOutputJson,
  DataAnalyticsReplacementVehicleResourceReplacementVehicleOutputJson,
  DataAnalyticsServicePartnerChainResourceServicePartnerChainOutputJson,
  DataAnalyticsServicePartnerResourceServicePartnerOutputJson,
  DataAnalyticsServicePartnerResourceServicePartnerPreferredOutputJson,
  DataAnalyticsSourceResourceSourceOutputJson,
  DataAnalyticsTotalDossiersResourceTotalDossiersOutputJson,
  DataAnalyticsTowedAwayResourceTowedAwayOutputJson,
  DataAnalyticsTypeOfDamageResourceTypeOfDamageOutputJson,
  DataAnalyticsVehicleAlreadyAtRepairerResourceVehicleAlreadyAtRepairerOutputJson,
  ErrorJsonJsonproblem,
  ErrorJsonldJsonld,
  GetDataAnalyticsBrandParams,
  GetDataAnalyticsCauseOfDamageParams,
  GetDataAnalyticsDamageFromDirectionParams,
  GetDataAnalyticsDealershipLocationParams,
  GetDataAnalyticsDossierTypeParams,
  GetDataAnalyticsDossiersPerDamageDateParams,
  GetDataAnalyticsDriveableParams,
  GetDataAnalyticsExternalInsuredParams,
  GetDataAnalyticsFleetLeaseLabelTypeParams,
  GetDataAnalyticsGlassJobTypeParams,
  GetDataAnalyticsGuaranteeFundParams,
  GetDataAnalyticsHasImagesParams,
  GetDataAnalyticsHasRepairAppointmentParams,
  GetDataAnalyticsLeaseCompanyParams,
  GetDataAnalyticsMediaIntentPerDayParams,
  GetDataAnalyticsOtherPartyInvolvedParams,
  GetDataAnalyticsOwnershipParams,
  GetDataAnalyticsPhotosPerDossierParams,
  GetDataAnalyticsRepairRequestedParams,
  GetDataAnalyticsRepairTypeParams,
  GetDataAnalyticsReplacementVehicleParams,
  GetDataAnalyticsServicePartnerChainParams,
  GetDataAnalyticsServicePartnerParams,
  GetDataAnalyticsServicePartnerPreferredParams,
  GetDataAnalyticsSourceParams,
  GetDataAnalyticsTotalDossiersParams,
  GetDataAnalyticsTowedAwayParams,
  GetDataAnalyticsTypeOfDamageParams,
  GetDataAnalyticsVehicleAlreadyAtRepairerParams
} from '../model';

import { customInstance } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Get brand analytics for a given time period
 * @summary Get brand analytics
 */
export const getDataAnalyticsBrand = (
    params: GetDataAnalyticsBrandParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsBrandResourceBrandOutputJson>(
      {url: `/data-analytics/brand`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsBrandQueryKey = (params?: GetDataAnalyticsBrandParams,) => {
    return [
    `/data-analytics/brand`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsBrandQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsBrand>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsBrandParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsBrandQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsBrand>>> = ({ signal }) => getDataAnalyticsBrand(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsBrand>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsBrandQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsBrand>>>
export type GetDataAnalyticsBrandQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsBrand<TData = Awaited<ReturnType<typeof getDataAnalyticsBrand>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsBrandParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsBrand>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsBrand>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsBrand>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsBrand<TData = Awaited<ReturnType<typeof getDataAnalyticsBrand>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsBrandParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsBrand>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsBrand>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsBrand>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsBrand<TData = Awaited<ReturnType<typeof getDataAnalyticsBrand>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsBrandParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get brand analytics
 */

export function useGetDataAnalyticsBrand<TData = Awaited<ReturnType<typeof getDataAnalyticsBrand>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsBrandParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsBrandQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get cause of damage analytics for a given time period. Translations for the returned keys can be found in the `cause-of-damage` API-resource (enum)
 * @summary Get cause of damage analytics
 */
export const getDataAnalyticsCauseOfDamage = (
    params: GetDataAnalyticsCauseOfDamageParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsCauseOfDamageResourceCauseOfDamageOutputJson>(
      {url: `/data-analytics/cause-of-damage`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsCauseOfDamageQueryKey = (params?: GetDataAnalyticsCauseOfDamageParams,) => {
    return [
    `/data-analytics/cause-of-damage`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsCauseOfDamageQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsCauseOfDamageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsCauseOfDamageQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>> = ({ signal }) => getDataAnalyticsCauseOfDamage(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsCauseOfDamageQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>>
export type GetDataAnalyticsCauseOfDamageQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsCauseOfDamage<TData = Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsCauseOfDamageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsCauseOfDamage<TData = Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsCauseOfDamageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsCauseOfDamage<TData = Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsCauseOfDamageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get cause of damage analytics
 */

export function useGetDataAnalyticsCauseOfDamage<TData = Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsCauseOfDamageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsCauseOfDamage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsCauseOfDamageQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get damage from direction analytics for a given time period. Translations for the returned keys can be found in the `damage-from-direction` API-resource (enum)
 * @summary Get damage from direction analytics
 */
export const getDataAnalyticsDamageFromDirection = (
    params: GetDataAnalyticsDamageFromDirectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsDamageFromDirectionResourceDamageFromDirectionOutputJson>(
      {url: `/data-analytics/damage-from-direction`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsDamageFromDirectionQueryKey = (params?: GetDataAnalyticsDamageFromDirectionParams,) => {
    return [
    `/data-analytics/damage-from-direction`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsDamageFromDirectionQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsDamageFromDirectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsDamageFromDirectionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>> = ({ signal }) => getDataAnalyticsDamageFromDirection(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsDamageFromDirectionQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>>
export type GetDataAnalyticsDamageFromDirectionQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsDamageFromDirection<TData = Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDamageFromDirectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsDamageFromDirection<TData = Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDamageFromDirectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsDamageFromDirection<TData = Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDamageFromDirectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get damage from direction analytics
 */

export function useGetDataAnalyticsDamageFromDirection<TData = Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDamageFromDirectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDamageFromDirection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsDamageFromDirectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get dealership location analytics for a given time period
 * @summary Get dealership location analytics
 */
export const getDataAnalyticsDealershipLocation = (
    params: GetDataAnalyticsDealershipLocationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsDealershipLocationResourceDealershipLocationOutputJson>(
      {url: `/data-analytics/dealership-location`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsDealershipLocationQueryKey = (params?: GetDataAnalyticsDealershipLocationParams,) => {
    return [
    `/data-analytics/dealership-location`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsDealershipLocationQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsDealershipLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsDealershipLocationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>> = ({ signal }) => getDataAnalyticsDealershipLocation(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsDealershipLocationQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>>
export type GetDataAnalyticsDealershipLocationQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsDealershipLocation<TData = Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDealershipLocationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsDealershipLocation<TData = Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDealershipLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsDealershipLocation<TData = Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDealershipLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get dealership location analytics
 */

export function useGetDataAnalyticsDealershipLocation<TData = Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDealershipLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDealershipLocation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsDealershipLocationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get dossier type analytics for a given time period
 * @summary Get dossier type analytics
 */
export const getDataAnalyticsDossierType = (
    params: GetDataAnalyticsDossierTypeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsDossierTypeResourceDossierTypeOutputJson>(
      {url: `/data-analytics/dossier-type`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsDossierTypeQueryKey = (params?: GetDataAnalyticsDossierTypeParams,) => {
    return [
    `/data-analytics/dossier-type`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsDossierTypeQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsDossierType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsDossierTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDossierType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsDossierTypeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsDossierType>>> = ({ signal }) => getDataAnalyticsDossierType(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDossierType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsDossierTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsDossierType>>>
export type GetDataAnalyticsDossierTypeQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsDossierType<TData = Awaited<ReturnType<typeof getDataAnalyticsDossierType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDossierTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDossierType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsDossierType>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsDossierType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsDossierType<TData = Awaited<ReturnType<typeof getDataAnalyticsDossierType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDossierTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDossierType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsDossierType>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsDossierType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsDossierType<TData = Awaited<ReturnType<typeof getDataAnalyticsDossierType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDossierTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDossierType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get dossier type analytics
 */

export function useGetDataAnalyticsDossierType<TData = Awaited<ReturnType<typeof getDataAnalyticsDossierType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDossierTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDossierType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsDossierTypeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get the number of dossiers per calendar day of the damage. The period filters on the day the dossier was created, while the buckets are the days the damage occurred, expressed in the application timezone. A dossier created in the period may carry a damage date outside it, so returned days may fall outside the requested period. Only days on which damage occurred are present; days are not zero-filled. Dossiers without a recorded damage date are returned under the "-" key.
 * @summary Get dossiers per damage date analytics
 */
export const getDataAnalyticsDossiersPerDamageDate = (
    params: GetDataAnalyticsDossiersPerDamageDateParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsDossiersPerDamageDateResourceDossiersPerDamageDateOutputJson>(
      {url: `/data-analytics/dossiers-per-damage-date`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsDossiersPerDamageDateQueryKey = (params?: GetDataAnalyticsDossiersPerDamageDateParams,) => {
    return [
    `/data-analytics/dossiers-per-damage-date`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsDossiersPerDamageDateQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsDossiersPerDamageDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsDossiersPerDamageDateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>> = ({ signal }) => getDataAnalyticsDossiersPerDamageDate(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsDossiersPerDamageDateQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>>
export type GetDataAnalyticsDossiersPerDamageDateQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsDossiersPerDamageDate<TData = Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDossiersPerDamageDateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsDossiersPerDamageDate<TData = Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDossiersPerDamageDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsDossiersPerDamageDate<TData = Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDossiersPerDamageDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get dossiers per damage date analytics
 */

export function useGetDataAnalyticsDossiersPerDamageDate<TData = Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDossiersPerDamageDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDossiersPerDamageDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsDossiersPerDamageDateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get driveable analytics for a given time period. Dossiers where the value was never recorded are reported as "-".
 * @summary Get driveable analytics
 */
export const getDataAnalyticsDriveable = (
    params: GetDataAnalyticsDriveableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsDriveableResourceDriveableOutputJson>(
      {url: `/data-analytics/driveable`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsDriveableQueryKey = (params?: GetDataAnalyticsDriveableParams,) => {
    return [
    `/data-analytics/driveable`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsDriveableQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsDriveable>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsDriveableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDriveable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsDriveableQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsDriveable>>> = ({ signal }) => getDataAnalyticsDriveable(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDriveable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsDriveableQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsDriveable>>>
export type GetDataAnalyticsDriveableQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsDriveable<TData = Awaited<ReturnType<typeof getDataAnalyticsDriveable>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDriveableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDriveable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsDriveable>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsDriveable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsDriveable<TData = Awaited<ReturnType<typeof getDataAnalyticsDriveable>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDriveableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDriveable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsDriveable>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsDriveable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsDriveable<TData = Awaited<ReturnType<typeof getDataAnalyticsDriveable>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDriveableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDriveable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get driveable analytics
 */

export function useGetDataAnalyticsDriveable<TData = Awaited<ReturnType<typeof getDataAnalyticsDriveable>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsDriveableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsDriveable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsDriveableQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get external insurance analytics for a given time period. The value comes from the fleet import rather than from the customer journey; dossiers without a fleet record, or whose fleet record was deleted, fall under the "-" key.
 * @summary Get external insured analytics
 */
export const getDataAnalyticsExternalInsured = (
    params: GetDataAnalyticsExternalInsuredParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsExternalInsuredResourceExternalInsuredOutputJson>(
      {url: `/data-analytics/external-insured`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsExternalInsuredQueryKey = (params?: GetDataAnalyticsExternalInsuredParams,) => {
    return [
    `/data-analytics/external-insured`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsExternalInsuredQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsExternalInsuredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsExternalInsuredQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>> = ({ signal }) => getDataAnalyticsExternalInsured(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsExternalInsuredQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>>
export type GetDataAnalyticsExternalInsuredQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsExternalInsured<TData = Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsExternalInsuredParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsExternalInsured<TData = Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsExternalInsuredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsExternalInsured<TData = Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsExternalInsuredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get external insured analytics
 */

export function useGetDataAnalyticsExternalInsured<TData = Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsExternalInsuredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsExternalInsured>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsExternalInsuredQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get the number of dossiers per customer type (b2b or b2c) of the lease label the vehicle belongs to. The type sits on the lease label rather than on the dossier, so dossiers whose vehicle has no fleet record, or whose fleet record carries no lease label, fall under the "-" key.
 * @summary Get fleet lease label type analytics
 */
export const getDataAnalyticsFleetLeaseLabelType = (
    params: GetDataAnalyticsFleetLeaseLabelTypeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsFleetLeaseLabelTypeResourceFleetLeaseLabelTypeOutputJson>(
      {url: `/data-analytics/fleet-lease-label-type`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsFleetLeaseLabelTypeQueryKey = (params?: GetDataAnalyticsFleetLeaseLabelTypeParams,) => {
    return [
    `/data-analytics/fleet-lease-label-type`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsFleetLeaseLabelTypeQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsFleetLeaseLabelTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsFleetLeaseLabelTypeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>> = ({ signal }) => getDataAnalyticsFleetLeaseLabelType(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsFleetLeaseLabelTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>>
export type GetDataAnalyticsFleetLeaseLabelTypeQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsFleetLeaseLabelType<TData = Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsFleetLeaseLabelTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsFleetLeaseLabelType<TData = Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsFleetLeaseLabelTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsFleetLeaseLabelType<TData = Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsFleetLeaseLabelTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fleet lease label type analytics
 */

export function useGetDataAnalyticsFleetLeaseLabelType<TData = Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsFleetLeaseLabelTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsFleetLeaseLabelType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsFleetLeaseLabelTypeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get glass job type analytics for a given time period. Only glass dossiers carry a job type, so the statistic only counts glass dossiers
 * @summary Get glass job type analytics
 */
export const getDataAnalyticsGlassJobType = (
    params: GetDataAnalyticsGlassJobTypeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsGlassJobTypeResourceGlassJobTypeOutputJson>(
      {url: `/data-analytics/glass-job-type`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsGlassJobTypeQueryKey = (params?: GetDataAnalyticsGlassJobTypeParams,) => {
    return [
    `/data-analytics/glass-job-type`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsGlassJobTypeQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsGlassJobTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsGlassJobTypeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>> = ({ signal }) => getDataAnalyticsGlassJobType(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsGlassJobTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>>
export type GetDataAnalyticsGlassJobTypeQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsGlassJobType<TData = Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsGlassJobTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsGlassJobType<TData = Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsGlassJobTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsGlassJobType<TData = Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsGlassJobTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get glass job type analytics
 */

export function useGetDataAnalyticsGlassJobType<TData = Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsGlassJobTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsGlassJobType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsGlassJobTypeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get guarantee fund (Waarborgfonds) analytics for a given time period. Only generic RepairDirect dossiers carry this field, so the buckets add up to that subset rather than to the total number of dossiers in the period. Within it, the underlying question is only asked for a specific damage scenario, so most dossiers fall under the "-" key.
 * @summary Get guarantee fund analytics
 */
export const getDataAnalyticsGuaranteeFund = (
    params: GetDataAnalyticsGuaranteeFundParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsGuaranteeFundResourceGuaranteeFundOutputJson>(
      {url: `/data-analytics/guarantee-fund`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsGuaranteeFundQueryKey = (params?: GetDataAnalyticsGuaranteeFundParams,) => {
    return [
    `/data-analytics/guarantee-fund`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsGuaranteeFundQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsGuaranteeFundParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsGuaranteeFundQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>> = ({ signal }) => getDataAnalyticsGuaranteeFund(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsGuaranteeFundQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>>
export type GetDataAnalyticsGuaranteeFundQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsGuaranteeFund<TData = Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsGuaranteeFundParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsGuaranteeFund<TData = Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsGuaranteeFundParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsGuaranteeFund<TData = Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsGuaranteeFundParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get guarantee fund analytics
 */

export function useGetDataAnalyticsGuaranteeFund<TData = Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsGuaranteeFundParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsGuaranteeFund>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsGuaranteeFundQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get has images analytics for a given time period
 * @summary Get has images analytics
 */
export const getDataAnalyticsHasImages = (
    params: GetDataAnalyticsHasImagesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsHasImagesResourceHasImagesOutputJson>(
      {url: `/data-analytics/has-images`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsHasImagesQueryKey = (params?: GetDataAnalyticsHasImagesParams,) => {
    return [
    `/data-analytics/has-images`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsHasImagesQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsHasImages>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsHasImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsHasImages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsHasImagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsHasImages>>> = ({ signal }) => getDataAnalyticsHasImages(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsHasImages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsHasImagesQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsHasImages>>>
export type GetDataAnalyticsHasImagesQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsHasImages<TData = Awaited<ReturnType<typeof getDataAnalyticsHasImages>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsHasImagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsHasImages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsHasImages>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsHasImages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsHasImages<TData = Awaited<ReturnType<typeof getDataAnalyticsHasImages>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsHasImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsHasImages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsHasImages>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsHasImages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsHasImages<TData = Awaited<ReturnType<typeof getDataAnalyticsHasImages>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsHasImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsHasImages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get has images analytics
 */

export function useGetDataAnalyticsHasImages<TData = Awaited<ReturnType<typeof getDataAnalyticsHasImages>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsHasImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsHasImages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsHasImagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get has repair appointment analytics for a given time period
 * @summary Get has repair appointment analytics
 */
export const getDataAnalyticsHasRepairAppointment = (
    params: GetDataAnalyticsHasRepairAppointmentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsHasRepairAppointmentResourceHasRepairAppointmentOutputJson>(
      {url: `/data-analytics/has-repair-appointment`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsHasRepairAppointmentQueryKey = (params?: GetDataAnalyticsHasRepairAppointmentParams,) => {
    return [
    `/data-analytics/has-repair-appointment`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsHasRepairAppointmentQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsHasRepairAppointmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsHasRepairAppointmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>> = ({ signal }) => getDataAnalyticsHasRepairAppointment(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsHasRepairAppointmentQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>>
export type GetDataAnalyticsHasRepairAppointmentQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsHasRepairAppointment<TData = Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsHasRepairAppointmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsHasRepairAppointment<TData = Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsHasRepairAppointmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsHasRepairAppointment<TData = Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsHasRepairAppointmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get has repair appointment analytics
 */

export function useGetDataAnalyticsHasRepairAppointment<TData = Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsHasRepairAppointmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsHasRepairAppointment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsHasRepairAppointmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get lease company analytics for a given time period
 * @summary Get lease company analytics
 */
export const getDataAnalyticsLeaseCompany = (
    params: GetDataAnalyticsLeaseCompanyParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsLeaseCompanyResourceLeaseCompanyOutputJson>(
      {url: `/data-analytics/lease-company`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsLeaseCompanyQueryKey = (params?: GetDataAnalyticsLeaseCompanyParams,) => {
    return [
    `/data-analytics/lease-company`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsLeaseCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsLeaseCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsLeaseCompanyQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>> = ({ signal }) => getDataAnalyticsLeaseCompany(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsLeaseCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>>
export type GetDataAnalyticsLeaseCompanyQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsLeaseCompany<TData = Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsLeaseCompanyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsLeaseCompany<TData = Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsLeaseCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsLeaseCompany<TData = Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsLeaseCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get lease company analytics
 */

export function useGetDataAnalyticsLeaseCompany<TData = Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsLeaseCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsLeaseCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsLeaseCompanyQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get the number of media files with the requested intent that were attached to a dossier, per calendar day. Use intent=accident_report for the number of accident reports (SAF) received. The day is the day the file arrived, not the day the dossier was created, and is expressed in the application timezone. Every day in the period is present, including days with a count of 0, so the period is limited to 366 days.
 * @summary Get media per day analytics for a given intent
 */
export const getDataAnalyticsMediaIntentPerDay = (
    params: GetDataAnalyticsMediaIntentPerDayParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsMediaIntentPerDayResourceMediaIntentPerDayOutputJson>(
      {url: `/data-analytics/media-intent-per-day`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsMediaIntentPerDayQueryKey = (params?: GetDataAnalyticsMediaIntentPerDayParams,) => {
    return [
    `/data-analytics/media-intent-per-day`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsMediaIntentPerDayQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsMediaIntentPerDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsMediaIntentPerDayQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>> = ({ signal }) => getDataAnalyticsMediaIntentPerDay(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsMediaIntentPerDayQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>>
export type GetDataAnalyticsMediaIntentPerDayQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsMediaIntentPerDay<TData = Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsMediaIntentPerDayParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsMediaIntentPerDay<TData = Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsMediaIntentPerDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsMediaIntentPerDay<TData = Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsMediaIntentPerDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get media per day analytics for a given intent
 */

export function useGetDataAnalyticsMediaIntentPerDay<TData = Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsMediaIntentPerDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsMediaIntentPerDay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsMediaIntentPerDayQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get the number of dossiers per OtherParty outcome for a given time period. The enum cases are reported separately, so "an other party was involved but is unknown" stays distinct from "no other party"; add them up for a plain yes/no split. Dossiers where the question was never answered are reported as "-".
 * @summary Get other party involved analytics
 */
export const getDataAnalyticsOtherPartyInvolved = (
    params: GetDataAnalyticsOtherPartyInvolvedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsOtherPartyInvolvedResourceOtherPartyInvolvedOutputJson>(
      {url: `/data-analytics/other-party-involved`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsOtherPartyInvolvedQueryKey = (params?: GetDataAnalyticsOtherPartyInvolvedParams,) => {
    return [
    `/data-analytics/other-party-involved`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsOtherPartyInvolvedQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsOtherPartyInvolvedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsOtherPartyInvolvedQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>> = ({ signal }) => getDataAnalyticsOtherPartyInvolved(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsOtherPartyInvolvedQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>>
export type GetDataAnalyticsOtherPartyInvolvedQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsOtherPartyInvolved<TData = Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsOtherPartyInvolvedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsOtherPartyInvolved<TData = Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsOtherPartyInvolvedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsOtherPartyInvolved<TData = Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsOtherPartyInvolvedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get other party involved analytics
 */

export function useGetDataAnalyticsOtherPartyInvolved<TData = Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsOtherPartyInvolvedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsOtherPartyInvolved>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsOtherPartyInvolvedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get ownership analytics for a given time period
 * @summary Get ownership analytics
 */
export const getDataAnalyticsOwnership = (
    params: GetDataAnalyticsOwnershipParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsOwnershipResourceOwnershipOutputJson>(
      {url: `/data-analytics/ownership`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsOwnershipQueryKey = (params?: GetDataAnalyticsOwnershipParams,) => {
    return [
    `/data-analytics/ownership`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsOwnershipQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsOwnership>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsOwnershipParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsOwnership>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsOwnershipQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsOwnership>>> = ({ signal }) => getDataAnalyticsOwnership(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsOwnership>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsOwnershipQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsOwnership>>>
export type GetDataAnalyticsOwnershipQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsOwnership<TData = Awaited<ReturnType<typeof getDataAnalyticsOwnership>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsOwnershipParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsOwnership>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsOwnership>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsOwnership>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsOwnership<TData = Awaited<ReturnType<typeof getDataAnalyticsOwnership>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsOwnershipParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsOwnership>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsOwnership>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsOwnership>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsOwnership<TData = Awaited<ReturnType<typeof getDataAnalyticsOwnership>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsOwnershipParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsOwnership>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get ownership analytics
 */

export function useGetDataAnalyticsOwnership<TData = Awaited<ReturnType<typeof getDataAnalyticsOwnership>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsOwnershipParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsOwnership>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsOwnershipQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get how many dossiers carried how many damage photos, for a given time period, ascending by photo count. The entry with photoCount 0 is how many damages arrived without a single photo. Photos delivered through image capture are included, because they are attached to the dossier as well. Only intents that depict damage are counted, so documents such as an accident report or an insurance card do not inflate the figure. Counts are not grouped into ranges, because where those boundaries sit differs per client and per chart.
 * @summary Get photos per dossier analytics
 */
export const getDataAnalyticsPhotosPerDossier = (
    params: GetDataAnalyticsPhotosPerDossierParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsPhotosPerDossierResourcePhotosPerDossierOutputJson>(
      {url: `/data-analytics/photos-per-dossier`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsPhotosPerDossierQueryKey = (params?: GetDataAnalyticsPhotosPerDossierParams,) => {
    return [
    `/data-analytics/photos-per-dossier`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsPhotosPerDossierQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsPhotosPerDossierParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsPhotosPerDossierQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>> = ({ signal }) => getDataAnalyticsPhotosPerDossier(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsPhotosPerDossierQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>>
export type GetDataAnalyticsPhotosPerDossierQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsPhotosPerDossier<TData = Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsPhotosPerDossierParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsPhotosPerDossier<TData = Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsPhotosPerDossierParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsPhotosPerDossier<TData = Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsPhotosPerDossierParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get photos per dossier analytics
 */

export function useGetDataAnalyticsPhotosPerDossier<TData = Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsPhotosPerDossierParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsPhotosPerDossier>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsPhotosPerDossierQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get repair requested analytics for a given time period. Dossiers where the value was never recorded are reported as "-".
 * @summary Get repair requested analytics
 */
export const getDataAnalyticsRepairRequested = (
    params: GetDataAnalyticsRepairRequestedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsRepairRequestedResourceRepairRequestedOutputJson>(
      {url: `/data-analytics/repair-requested`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsRepairRequestedQueryKey = (params?: GetDataAnalyticsRepairRequestedParams,) => {
    return [
    `/data-analytics/repair-requested`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsRepairRequestedQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsRepairRequestedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsRepairRequestedQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>> = ({ signal }) => getDataAnalyticsRepairRequested(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsRepairRequestedQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>>
export type GetDataAnalyticsRepairRequestedQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsRepairRequested<TData = Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsRepairRequestedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsRepairRequested<TData = Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsRepairRequestedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsRepairRequested<TData = Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsRepairRequestedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get repair requested analytics
 */

export function useGetDataAnalyticsRepairRequested<TData = Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsRepairRequestedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsRepairRequested>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsRepairRequestedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get repair type analytics for a given time period. Only generic RepairDirect dossiers carry a repair type, so the statistic only counts that dossier family. The distribution currently has exactly two keys: `smart-repair`, and the placeholder for dossiers where no repair type was recorded; if a second repair type is ever added to the enum, it appears as an additional key with no change to this endpoint
 * @summary Get repair type analytics
 */
export const getDataAnalyticsRepairType = (
    params: GetDataAnalyticsRepairTypeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsRepairTypeResourceRepairTypeOutputJson>(
      {url: `/data-analytics/repair-type`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsRepairTypeQueryKey = (params?: GetDataAnalyticsRepairTypeParams,) => {
    return [
    `/data-analytics/repair-type`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsRepairTypeQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsRepairType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsRepairTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsRepairType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsRepairTypeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsRepairType>>> = ({ signal }) => getDataAnalyticsRepairType(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsRepairType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsRepairTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsRepairType>>>
export type GetDataAnalyticsRepairTypeQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsRepairType<TData = Awaited<ReturnType<typeof getDataAnalyticsRepairType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsRepairTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsRepairType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsRepairType>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsRepairType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsRepairType<TData = Awaited<ReturnType<typeof getDataAnalyticsRepairType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsRepairTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsRepairType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsRepairType>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsRepairType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsRepairType<TData = Awaited<ReturnType<typeof getDataAnalyticsRepairType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsRepairTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsRepairType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get repair type analytics
 */

export function useGetDataAnalyticsRepairType<TData = Awaited<ReturnType<typeof getDataAnalyticsRepairType>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsRepairTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsRepairType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsRepairTypeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get replacement vehicle analytics for a given time period. Dossiers where the value was never recorded are reported as "-".
 * @summary Get replacement vehicle analytics
 */
export const getDataAnalyticsReplacementVehicle = (
    params: GetDataAnalyticsReplacementVehicleParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsReplacementVehicleResourceReplacementVehicleOutputJson>(
      {url: `/data-analytics/replacement-vehicle`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsReplacementVehicleQueryKey = (params?: GetDataAnalyticsReplacementVehicleParams,) => {
    return [
    `/data-analytics/replacement-vehicle`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsReplacementVehicleQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsReplacementVehicleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsReplacementVehicleQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>> = ({ signal }) => getDataAnalyticsReplacementVehicle(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsReplacementVehicleQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>>
export type GetDataAnalyticsReplacementVehicleQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsReplacementVehicle<TData = Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsReplacementVehicleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsReplacementVehicle<TData = Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsReplacementVehicleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsReplacementVehicle<TData = Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsReplacementVehicleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get replacement vehicle analytics
 */

export function useGetDataAnalyticsReplacementVehicle<TData = Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsReplacementVehicleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsReplacementVehicle>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsReplacementVehicleQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get service partner analytics for a given time period
 * @summary Get service partner analytics
 */
export const getDataAnalyticsServicePartner = (
    params: GetDataAnalyticsServicePartnerParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsServicePartnerResourceServicePartnerOutputJson>(
      {url: `/data-analytics/service-partner`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsServicePartnerQueryKey = (params?: GetDataAnalyticsServicePartnerParams,) => {
    return [
    `/data-analytics/service-partner`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsServicePartnerQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsServicePartnerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsServicePartnerQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>> = ({ signal }) => getDataAnalyticsServicePartner(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsServicePartnerQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>>
export type GetDataAnalyticsServicePartnerQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsServicePartner<TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsServicePartnerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsServicePartner<TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsServicePartnerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsServicePartner<TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsServicePartnerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get service partner analytics
 */

export function useGetDataAnalyticsServicePartner<TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsServicePartnerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartner>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsServicePartnerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get service partner chain analytics for a given time period
 * @summary Get service partner chain analytics
 */
export const getDataAnalyticsServicePartnerChain = (
    params: GetDataAnalyticsServicePartnerChainParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsServicePartnerChainResourceServicePartnerChainOutputJson>(
      {url: `/data-analytics/service-partner-chain`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsServicePartnerChainQueryKey = (params?: GetDataAnalyticsServicePartnerChainParams,) => {
    return [
    `/data-analytics/service-partner-chain`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsServicePartnerChainQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsServicePartnerChainParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsServicePartnerChainQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>> = ({ signal }) => getDataAnalyticsServicePartnerChain(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsServicePartnerChainQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>>
export type GetDataAnalyticsServicePartnerChainQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsServicePartnerChain<TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsServicePartnerChainParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsServicePartnerChain<TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsServicePartnerChainParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsServicePartnerChain<TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsServicePartnerChainParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get service partner chain analytics
 */

export function useGetDataAnalyticsServicePartnerChain<TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsServicePartnerChainParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerChain>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsServicePartnerChainQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get service partner preferred partner analytics for a given time period
 * @summary Get service partner preferred partner analytics
 */
export const getDataAnalyticsServicePartnerPreferred = (
    params: GetDataAnalyticsServicePartnerPreferredParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsServicePartnerResourceServicePartnerPreferredOutputJson>(
      {url: `/data-analytics/service-partner-preferred`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsServicePartnerPreferredQueryKey = (params?: GetDataAnalyticsServicePartnerPreferredParams,) => {
    return [
    `/data-analytics/service-partner-preferred`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsServicePartnerPreferredQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsServicePartnerPreferredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsServicePartnerPreferredQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>> = ({ signal }) => getDataAnalyticsServicePartnerPreferred(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsServicePartnerPreferredQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>>
export type GetDataAnalyticsServicePartnerPreferredQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsServicePartnerPreferred<TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsServicePartnerPreferredParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsServicePartnerPreferred<TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsServicePartnerPreferredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsServicePartnerPreferred<TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsServicePartnerPreferredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get service partner preferred partner analytics
 */

export function useGetDataAnalyticsServicePartnerPreferred<TData = Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsServicePartnerPreferredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsServicePartnerPreferred>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsServicePartnerPreferredQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get source analytics for a given time period
 * @summary Get source analytics
 */
export const getDataAnalyticsSource = (
    params: GetDataAnalyticsSourceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsSourceResourceSourceOutputJson>(
      {url: `/data-analytics/source`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsSourceQueryKey = (params?: GetDataAnalyticsSourceParams,) => {
    return [
    `/data-analytics/source`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsSourceQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsSource>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsSourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsSource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsSourceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsSource>>> = ({ signal }) => getDataAnalyticsSource(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsSource>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsSourceQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsSource>>>
export type GetDataAnalyticsSourceQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsSource<TData = Awaited<ReturnType<typeof getDataAnalyticsSource>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsSourceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsSource>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsSource>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsSource>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsSource<TData = Awaited<ReturnType<typeof getDataAnalyticsSource>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsSourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsSource>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsSource>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsSource>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsSource<TData = Awaited<ReturnType<typeof getDataAnalyticsSource>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsSourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsSource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get source analytics
 */

export function useGetDataAnalyticsSource<TData = Awaited<ReturnType<typeof getDataAnalyticsSource>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsSourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsSource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsSourceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get total number of dossiers for a given time period
 * @summary Get total dossiers analytics
 */
export const getDataAnalyticsTotalDossiers = (
    params: GetDataAnalyticsTotalDossiersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsTotalDossiersResourceTotalDossiersOutputJson>(
      {url: `/data-analytics/total-dossiers`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsTotalDossiersQueryKey = (params?: GetDataAnalyticsTotalDossiersParams,) => {
    return [
    `/data-analytics/total-dossiers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsTotalDossiersQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsTotalDossiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsTotalDossiersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>> = ({ signal }) => getDataAnalyticsTotalDossiers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsTotalDossiersQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>>
export type GetDataAnalyticsTotalDossiersQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsTotalDossiers<TData = Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsTotalDossiersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsTotalDossiers<TData = Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsTotalDossiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsTotalDossiers<TData = Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsTotalDossiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get total dossiers analytics
 */

export function useGetDataAnalyticsTotalDossiers<TData = Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsTotalDossiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTotalDossiers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsTotalDossiersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get towed away analytics for a given time period. Dossiers with no recorded value are reported as "-"; depending on the affiliate's customer journey the question may be conditional, in which case it also covers dossiers where the question was never asked.
 * @summary Get towed away analytics
 */
export const getDataAnalyticsTowedAway = (
    params: GetDataAnalyticsTowedAwayParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsTowedAwayResourceTowedAwayOutputJson>(
      {url: `/data-analytics/towed-away`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsTowedAwayQueryKey = (params?: GetDataAnalyticsTowedAwayParams,) => {
    return [
    `/data-analytics/towed-away`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsTowedAwayQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsTowedAwayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsTowedAwayQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>> = ({ signal }) => getDataAnalyticsTowedAway(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsTowedAwayQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>>
export type GetDataAnalyticsTowedAwayQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsTowedAway<TData = Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsTowedAwayParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsTowedAway<TData = Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsTowedAwayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsTowedAway<TData = Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsTowedAwayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get towed away analytics
 */

export function useGetDataAnalyticsTowedAway<TData = Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsTowedAwayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTowedAway>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsTowedAwayQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get type of damage analytics for a given time period. Translations for the returned keys can be found in the `type-of-damage` API-resource (enum)
 * @summary Get type of damage analytics
 */
export const getDataAnalyticsTypeOfDamage = (
    params: GetDataAnalyticsTypeOfDamageParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsTypeOfDamageResourceTypeOfDamageOutputJson>(
      {url: `/data-analytics/type-of-damage`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsTypeOfDamageQueryKey = (params?: GetDataAnalyticsTypeOfDamageParams,) => {
    return [
    `/data-analytics/type-of-damage`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsTypeOfDamageQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsTypeOfDamageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsTypeOfDamageQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>> = ({ signal }) => getDataAnalyticsTypeOfDamage(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsTypeOfDamageQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>>
export type GetDataAnalyticsTypeOfDamageQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsTypeOfDamage<TData = Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsTypeOfDamageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsTypeOfDamage<TData = Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsTypeOfDamageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsTypeOfDamage<TData = Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsTypeOfDamageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get type of damage analytics
 */

export function useGetDataAnalyticsTypeOfDamage<TData = Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsTypeOfDamageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsTypeOfDamage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsTypeOfDamageQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get how many dossiers reported the vehicle as already being at a repairer, for a given time period. The question is only asked when a repair is requested, and it decides whether the customer journey asks the driver to pick a repairer, so dossiers without a repair request fall under the "-" key. Only generic RepairDirect dossiers carry this field, so the buckets add up to that subset rather than to the total number of dossiers in the period.
 * @summary Get vehicle already at repairer analytics
 */
export const getDataAnalyticsVehicleAlreadyAtRepairer = (
    params: GetDataAnalyticsVehicleAlreadyAtRepairerParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DataAnalyticsVehicleAlreadyAtRepairerResourceVehicleAlreadyAtRepairerOutputJson>(
      {url: `/data-analytics/vehicle-already-at-repairer`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDataAnalyticsVehicleAlreadyAtRepairerQueryKey = (params?: GetDataAnalyticsVehicleAlreadyAtRepairerParams,) => {
    return [
    `/data-analytics/vehicle-already-at-repairer`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDataAnalyticsVehicleAlreadyAtRepairerQueryOptions = <TData = Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params: GetDataAnalyticsVehicleAlreadyAtRepairerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataAnalyticsVehicleAlreadyAtRepairerQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>> = ({ signal }) => getDataAnalyticsVehicleAlreadyAtRepairer(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataAnalyticsVehicleAlreadyAtRepairerQueryResult = NonNullable<Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>>
export type GetDataAnalyticsVehicleAlreadyAtRepairerQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDataAnalyticsVehicleAlreadyAtRepairer<TData = Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsVehicleAlreadyAtRepairerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsVehicleAlreadyAtRepairer<TData = Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsVehicleAlreadyAtRepairerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>,
          TError,
          Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataAnalyticsVehicleAlreadyAtRepairer<TData = Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsVehicleAlreadyAtRepairerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get vehicle already at repairer analytics
 */

export function useGetDataAnalyticsVehicleAlreadyAtRepairer<TData = Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: GetDataAnalyticsVehicleAlreadyAtRepairerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataAnalyticsVehicleAlreadyAtRepairer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataAnalyticsVehicleAlreadyAtRepairerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






